module.exports = __webpack_public_path__ + "static/media/pet1.1df40f1a.png";